import { render, staticRenderFns } from "./HomeMultiIdiomas.vue?vue&type=template&id=f3e70808&"
import script from "./HomeMultiIdiomas.vue?vue&type=script&lang=js&"
export * from "./HomeMultiIdiomas.vue?vue&type=script&lang=js&"
import style0 from "./HomeMultiIdiomas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports